var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 12.4999H14C14.3682 12.4999 14.6667 12.2015 14.6667 11.8333V7.83325C14.6667 6.72869 13.7713 5.83325 12.6667 5.83325H3.33337C2.22881 5.83325 1.33337 6.72869 1.33337 7.83325V11.8333C1.33337 12.2015 1.63185 12.4999 2.00004 12.4999H4.66671",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 8.16675H12.3394",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 5.83325V2.83325C11.3333 2.28097 10.8856 1.83325 10.3333 1.83325H5.66663C5.11434 1.83325 4.66663 2.28097 4.66663 2.83325V5.83325",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 11.1667V13.8334C11.3333 14.5698 10.7364 15.1667 9.99996 15.1667H5.99996C5.26358 15.1667 4.66663 14.5698 4.66663 13.8334V11.1667H11.3333Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.d59552bb59f389c67506ea9d21571ac2.svg";
export { ForwardRef as ReactComponent };